/**
 * BWA-Drilldown-Tabelle: 19 Zeilen in BWA-Reihenfolge (Z5–Z23), NICHT
 * alphabetisch (SCHEMA_MAPPING §2.2/§7). Spalten Soll/Ist/Abw mit Ampel.
 * null-IST → "—" (formatValue), abweichung_pct null → graue Ampel.
 * Zwischensummen (EvV/EBTDA/JÜ) hervorgehoben.
 */
import { BWA_KEYS, BWA_LABELS, BWA_SUBTOTAL_KEYS } from '../types/snapshot';
import type { BwaKey, Quarter } from '../types/snapshot';
import { formatEur } from '../lib/format';
import { Ampel } from './Ampel';

export interface BwaTableProps {
  quarter: Quarter | null;
  caption?: string;
  /**
   * Prompt 128 §1: Zeilen, die entfallen (durchgehend leere Immobilienzeilen einer
   * Nicht-Portfolio-Gesellschaft, lib/immoZeilen). Default: keine — alle 19 Zeilen.
   */
  ausblenden?: ReadonlySet<BwaKey>;
}

export function BwaTable({ quarter, caption, ausblenden }: BwaTableProps) {
  if (!quarter) {
    return (
      <p className="text-sm text-text-muted italic">
        Für dieses Quartal liegen keine Daten vor (geplant).
      </p>
    );
  }

  return (
    <table className="w-full border-collapse text-sm">
      {caption && <caption className="mb-2 text-left text-sm text-text-muted">{caption}</caption>}
      <thead>
        <tr className="border-b border-border text-text-muted">
          <th scope="col" className="py-2 text-left font-medium">
            BWA-Position
          </th>
          <th scope="col" className="py-2 text-right font-medium">
            Soll
          </th>
          <th scope="col" className="py-2 text-right font-medium">
            Ist
          </th>
          <th scope="col" className="py-2 text-right font-medium">
            Abweichung
          </th>
        </tr>
      </thead>
      <tbody>
        {BWA_KEYS.filter((key) => !ausblenden?.has(key)).map((key) => {
          const isSubtotal = BWA_SUBTOTAL_KEYS.has(key);
          return (
            <tr
              key={key}
              className={`border-b border-border/60 ${
                isSubtotal ? 'bg-surface-2 font-semibold' : ''
              }`}
            >
              <th scope="row" className="py-1.5 text-left font-normal">
                <span className={isSubtotal ? 'font-semibold' : ''}>{BWA_LABELS[key]}</span>
              </th>
              <td className="py-1.5 text-right tabular-nums">{formatEur(quarter.soll[key])}</td>
              <td className="py-1.5 text-right tabular-nums">
                {formatEur(quarter.ist[key], '—')}
              </td>
              <td className="py-1.5 text-right">
                <span className="inline-flex justify-end">
                  <Ampel
                    guenstigPct={quarter.abweichung_guenstig_pct?.[key]}
                    abweichungPct={quarter.abweichung_pct[key]}
                    showValue
                  />
                </span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
